<template>
  <split-pane :defaultPercent="20">
    <div class="mw-split-left" slot="paneL">
      <div class="mw-panel-y mw-panel__tree">
        <div class="mw-toolbar">
          <mw-button @click="createNode(currentNode)">新建
          </mw-button>
          <mw-button @click="removeNode(currentNode)">删除
          </mw-button>
          <el-dropdown trigger="hover" @command="handleMoreCommand">
            <el-button class="el-dropdown-link">
              更多<i class="el-icon-caret-bottom el-icon--right"></i>
            </el-button>
            <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
              <el-dropdown-item command="import" >导入</el-dropdown-item>
              <el-dropdown-item command="export">导出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="mw-toolbar__body mw-app__edit" ref="treeContainer">
          <mw-tree :treeData="treeData" :async="false" :multiple="false"
                  :expandedFirst="false" :autoLoad="true" :selectNode="selectNodeId"
                  :contextMenuItem="treeContextMenu" :dragEnable="false"
                  @changed="treeClick" ref="mwTree" ></mw-tree>
        </div>
      </div>
      <el-dialog ref="multilangDialog" title="新建" width="300px" :show-close="false" :before-close="beforeCloseDialogVisible" :visible.sync="multilangDialogVisible">
        <div style="width: 100%; height: 8px;"></div>
          <el-select v-model="selectOption" style="width: 100%;">
            <el-option label="请选择" value=""></el-option>
            <el-option :key="option.value" v-for="option in options" :label="option.label" :value="option.value"></el-option>
          </el-select>
        <div slot="footer" class="dialog-footer">
          <el-button @click="multilangDialogVisible = false">取 消</el-button>
          <el-button type="primary" :disabled="disabledNew" @click.prevent="newLanguage">确 定</el-button>
        </div>
      </el-dialog>
      <mw-dialog ref="impDialog" title="导入语言配置" size="mini_small" :footerButton="impBtton">
        <div class="mw-dialog_body" style="margin-top:20px;">
          <el-form label-width="100px"  >
            <el-col :span="24">
              <el-form-item label="上传文件:">
                <template>
                  <el-upload ref="importData"
                              :on-success="importSuccessCallback"
                              style="display: inline-block;"
                              :auto-upload="false"
                              :action="importAction"
                              multiple
                              :headers="headers"
                              :limit="1">
                    <el-button >获取文件</el-button>
                    <div slot="tip" style="" class="el-upload__tip">只能上传.xml文件</div>
                  </el-upload>
                </template>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
      </mw-dialog>
    </div>
    <div class="flow-config-dialog mw-split-right" slot="paneR">
      <div class="mw-toolbar">
        <el-form :inline="true" label-width="60px">
          <!-- <el-form-item label="名称：">
            <el-input readonly v-model='form.name'></el-input>
          </el-form-item> -->
          <!-- <el-form-item>
            <el-button @click="saveForm(1)" type="primary"><i class="fa fa-plus-square"></i>保存并关闭</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button  :disabled="disabledSave" @click="saveForm(0)" type="primary"><i class="fa fa-plus-square"></i>保存</el-button>
          </el-form-item>
          <el-form-item style="float:right;">
            <el-button @click="showHelp" type="info"><i class="fa fa-question"></i>帮助</el-button>
          </el-form-item>
          <el-form-item label="ID：" class="pull-right">
            {{form.id}}
            <!-- <el-input readonly v-model='form.id'></el-input> -->
          </el-form-item>
        </el-form>
      </div>
      <div class="mw-toolbar__body" style="overflow: hidden;">
        <div class="mw-panel">
          <div class="mw-panel mw-panel-class">
            <el-tabs v-model="valueTab" :stretch="true">
              <el-tab-pane label=" 键值对 " name="keyValue">
                <mw-code-edit lang="Text" :value="form.template" ref="formTemplate"></mw-code-edit>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </split-pane>
</template>

<script>
  export default {
    data() {
      return {
        treeData: [],
        lanData: [],
        treeContextMenu: [],
        selectNodeId: '',
        valueTab: 'keyValue',
        form:{
          name:"",
          category:"LanguagePack",
          template:"",
          id:"",
          code:""
        },
        multilangDialogVisible: false,
        selectOption: '',

        title:"",
        disabledSave: false,
        disabledNew: false,
        afterSavedLoad: false,
        options: [{
          value: 'en',
          label: '英语'
        }, {
          value: 'ja',
          label: '日语'
        }, {
          value: 'ko',
          label: '韩语'
        },{
          value:'zh-TW',
          label: '中文繁体'
        }],
        optionsMap: {'en':'英语', 'ja':'日语', 'ko':'韩语','zh-TW':'中文繁体'},
        importAction: '/api/app/impCompXml',
        headers: {},
        impBtton:[ {
          label: "取消",
          func:this.impCancel,
          type: "default"
        }, {
          label: "导入",
          func: this.import
        }]
      }
    },
    mounted:function() {
      var me=this;

      // 自定义语言切换
      if (window.$Env && window.$Env.customsLanguages) {
        me.options = window.$Env.customsLanguages;
        let customsLanguagesMap = {};
        if (window.$Env.customsLanguagesMap) {
          customsLanguagesMap = window.$Env.customsLanguagesMap;
        } else {
          _.each(window.$Env.customsLanguages, (it)=>{
            customsLanguagesMap[it.value] = it.label;
          })
        }
        me.optionsMap = customsLanguagesMap;
      }

      me.treeContextMenu=[{
        name: "删除",
        icon: 'fa fa-remove',
        label: '删除',
        func: function (selectData, selectParent, curBtn, item) {
          me.removeNode(selectData);
        }
      }];
      let contextMenu=PF.contextMenu({
        el:me.$refs.treeContainer,
        target:'.mw-tree-no-search__body',
        items:[{
          text:"新建",
          icon:"fa fa-plus",
          handler:function(){
            me.createNode();
          }
        }, {
          text:"删除",
          icon:"fa fa-remove",
          handler:function(){
            me.removeNode();
          }
        }]
      });
      me.$on("hook:destroyed",()=>{contextMenu.destroy()});
      me.loadTreeData();
    },
    methods: {
      loadTreeData(selected){
        let me = this;
        PF.invoke("s:multilang.srv.listMultilang", {category:'LanguagePack', sort:'createTime', dir:'desc'}).then(res => {
          me.treeData = [];
          if (res.result && res.result.length > 0) {
            if (!selected) {
              me.currentNode = res.result[0];
            } else {
              me.afterSavedLoad = true;
              me.currentNode = res.result.find((item)=>item.id = selected.id);
            }
            me.selectNodeId = me.currentNode.id;
          }
          me.lanData = res.result || [];
          me.lanData.forEach(item => {
            let temp = {};
            temp.id = item.id;
            temp.name = item.name;
            temp.hasChild = item.hasChild;
            if (!item.hasChild || item.hasChild == 0) temp.type = 'file';
            me.treeData.push(temp);
          });
        })
      },
      treeClick(node){
        this.currentNode = node;
        this.selectNodeId = node.id;
        const nodedata = this.lanData.find((item) => item.id == node.id);
        this.setForm(nodedata);
      },
      setForm(node){
        this.clearForm();
        this.form.id = node.id;
        this.form.name = node.name;
        this.form.category = node.category;
        this.form.code = node.code;
        if (node.template) {
          this.form.template = node.template;
        } else if (node.data) {
          let data = {};
          try {
            data = JSON.parse(node.data);
          } catch (error) {
            console.log(error);
          } finally {
            this.form.template = data.template || '';
          }
        }
      },
      clearForm(){
        this.form = {
          name:"",
          category:"LanguagePack",
          template:"",
          id:"",
          code:""
        }
      },
      createNode(node){
        this.multilangDialogVisible = true;
      },
      removeNode(node){
        var me = this;
        if (!node) {
          me.mwMsg("warning", "请选择要删除的语言!");
          return;
        }
        me.mwConfirm('此操作将删除该记录, 是否继续?').then(() => {
          const ids = [node.id];
          me.mwApi.app.removeComponent(ids).then((data) => {
            me.loadTreeData();
            me.mwMsg('删除成功!');
          });
        }).catch(() => {
        });
      },
      newLanguage(){
        let me = this;
        if (!me.selectOption) {
          me.mwMsg("warning", "请选择一种语言");
          return;
        }
        let form = {category: "LanguagePack"};
        form.code = me.selectOption;
        form.name = me.optionsMap[me.selectOption];
        me.disabledNew = true;
        me.saveForm(form);
      },
      beforeCloseDialogVisible(){
        this.selectOption = '';
      },
      saveForm(form){
        let me = this;
        var params = !form ? this.form : form;

        var hasData = false;
        _.each(me.lanData, (item, i)=>{
          if (item.code == params.code) hasData = true;
        })
        if (hasData && form) {
          me.mwMsg("danger", "该语言已添加, 请重新选择!");
          if (!form) {me.disabledSave = false;}
          else {me.disabledNew = false;}
          return;
        }

        if (!form) {
          params.template = me.mwRef('formTemplate').getValue();
          me.disabledSave = true;
        }
        PF.invoke("s:multilang.srv.saveMultilang", params).then((r) => {
          if (r.result) {
            me.multilangDialogVisible = false;
            if (!form) {
              me.disabledSave = false;
              _.each(me.lanData, (item) => {
                if (item.id == r.result.id) {
                  item.template = r.result.template;
                }
              });
            } else {
              me.disabledNew = false;
              me.loadTreeData(r.result);
            }
            me.mwMsg("success", "保存成功!");
          } else {
            me.mwMsg("danger", "添加语言失败,请重试!");
          }
        });
      },
      handleMoreCommand(command){
        let me=this;
        if(command === 'import'){
          this.mwRef('impDialog').show();
        }
        if(command === 'export'){
          me.exportNode(me.currentNode);
        }
      },
      import(){
        let me=this;
        me.mwRef("importData").submit();
      },
      impCancel() {
        this.mwRef('impDialog').hide();
      },
      importSuccessCallback(response, file, fileList) {
        if(response.result){
          this.loadTreeData();
          this.mwRef('impDialog').hide();
        }
        this.mwRef("importData").clearFiles();
      },
      exportNode(node){
        var me = this;
        if (!node) {
          me.mwMsg("warning", "请选择要导出的语言!");
          return;
        }
        const ids = [node.id];
        me.mwUtil.downloadAttachment(this.mwUrl("/api/app/expCompXml"),{},false,PF.encode({ids:ids}));
      },
      showHelp(){
        PF.showHelp({url:'/helpDoc/platform/multilingual.md'});
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/multilingual.vue